/* GTN header shooter — decorative pixel side-scroller (no libraries). Games Then and Now. */
(function () {
  'use strict';
  var PAL = { bg: '#120b22', bg2: '#1a1033', edge: '#4a3590', cyan: '#35e0ff', pink: '#ff4fa3', red: '#d62839', yellow: '#ffd23f', white: '#ffffff', rock: '#6b5a99', rockDark: '#3b2d66' };
  var ROCK = ['..###..', '.#####.', '##o####', '#####o#', '.##o##.', '..###..'];
  var SAUCER = ['...ccc...', '..ccccc..', 'ppppppppp', '.p.p.p.p.', '..ppppp..'];

  function drawSprite(ctx, rows, x, y, map) {
    for (var j = 0; j < rows.length; j++) {
      var r = rows[j];
      for (var i = 0; i < r.length; i++) {
        var c = map[r[i]];
        if (c) { ctx.fillStyle = c; ctx.fillRect(Math.round(x) + i, Math.round(y) + j, 1, 1); }
      }
    }
  }
  var ROCK_MAP = { '#': PAL.rock, 'o': PAL.rockDark };
  var SAUCER_MAP = { 'c': PAL.cyan, 'p': PAL.pink };

  function Shooter(canvas) {
    this.c = canvas;
    this.ctx = canvas.getContext('2d');
    this.reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.speed = parseFloat(canvas.getAttribute('data-speed')) || 1;
    this.ship = new Image();
    this.shipReady = false;
    var self = this;
    this.ship.onload = function () { self.shipReady = true; if (self.reduced || !self.running) self.render(); };
    this.ship.src = canvas.getAttribute('data-ship');
    this.running = false; this.visible = true; this.onscreen = true;
    this.resize();
    this.reset();
    if (window.ResizeObserver) new ResizeObserver(function () { self.resize(); self.render(); }).observe(canvas);
    if (this.reduced) { this.staticScene(); return; }
    document.addEventListener('visibilitychange', function () { self.visible = !document.hidden; self.toggle(); });
    if (window.IntersectionObserver) new IntersectionObserver(function (e) { self.onscreen = e[0].isIntersecting; self.toggle(); }).observe(canvas);
    this.toggle();
  }
  Shooter.prototype.resize = function () {
    var rect = this.c.getBoundingClientRect();
    var cssH = Math.max(rect.height, 30);
    this.scale = cssH >= 70 ? 3 : 2;
    this.w = Math.max(60, Math.ceil(rect.width / this.scale));
    this.h = Math.max(20, Math.ceil(cssH / this.scale));
    this.c.width = this.w; this.c.height = this.h;
    this.ctx.imageSmoothingEnabled = false;
    if (!this.stars) this.makeStars();
  };
  Shooter.prototype.makeStars = function () {
    this.stars = [];
    var n = Math.round(this.w * 0.18);
    for (var i = 0; i < n; i++) {
      var layer = i % 3;
      this.stars.push({ x: Math.random() * 2000, y: Math.random(), l: layer });
    }
  };
  Shooter.prototype.reset = function () {
    this.t = 0; this.shipX = -30; this.lasers = []; this.enemies = []; this.booms = [];
    this.nextEnemy = 0.4; this.nextShot = 0.8;
  };
  Shooter.prototype.shipSize = function () {
    var sh = Math.round(this.h * 0.38);
    var sw = this.shipReady ? Math.round(sh * (this.ship.naturalWidth / this.ship.naturalHeight || 2.2)) : Math.round(sh * 2.2);
    return { w: sw, h: sh };
  };
  Shooter.prototype.shipY = function () { var s = this.shipSize(); return (this.h - s.h) / 2 + Math.sin(this.t * 1.6) * (this.h * 0.18); };
  Shooter.prototype.spawn = function () {
    var saucer = Math.random() < 0.4;
    var spr = saucer ? SAUCER : ROCK;
    this.enemies.push({ x: this.w + 4, y: 2 + Math.random() * (this.h - spr.length - 4), v: (saucer ? 26 : 16) + Math.random() * 12, s: saucer, wob: Math.random() * 6 });
  };
  Shooter.prototype.boom = function (x, y) {
    var parts = [];
    var cols = [PAL.yellow, PAL.red, PAL.pink, PAL.white];
    for (var i = 0; i < 10; i++) { var a = Math.random() * Math.PI * 2, sp = 8 + Math.random() * 18; parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, c: cols[i % 4] }); }
    this.booms.push({ x: x, y: y, life: 0.45, age: 0, p: parts });
  };
  Shooter.prototype.update = function (dt) {
    dt *= this.speed; this.t += dt;
    var s = this.shipSize();
    this.shipX += dt * 14;
    if (this.shipX > this.w + 10) this.shipX = -s.w - 10;
    var sy = this.shipY();
    this.nextEnemy -= dt;
    if (this.nextEnemy <= 0) { this.spawn(); this.nextEnemy = 1.1 + Math.random() * 1.3; }
    this.nextShot -= dt;
    if (this.nextShot <= 0 && this.shipX > 0 && this.shipX < this.w - 20) { this.lasers.push({ x: this.shipX + s.w, y: Math.round(sy + s.h / 2) }); this.nextShot = 0.55; }
    var i, j;
    for (i = this.lasers.length - 1; i >= 0; i--) { this.lasers[i].x += dt * 110; if (this.lasers[i].x > this.w) this.lasers.splice(i, 1); }
    for (i = this.enemies.length - 1; i >= 0; i--) {
      var e = this.enemies[i]; e.x -= dt * e.v; if (e.s) e.y += Math.sin(this.t * 3 + e.wob) * dt * 4;
      var ew = e.s ? 9 : 7, eh = e.s ? 5 : 6, hit = false;
      for (j = this.lasers.length - 1; j >= 0; j--) {
        var L = this.lasers[j];
        if (L.x + 4 >= e.x && L.x <= e.x + ew && L.y >= e.y - 1 && L.y <= e.y + eh) { this.lasers.splice(j, 1); hit = true; break; }
      }
      if (hit) { this.boom(e.x + ew / 2, e.y + eh / 2); this.enemies.splice(i, 1); continue; }
      if (e.x < -12) this.enemies.splice(i, 1);
    }
    for (i = this.booms.length - 1; i >= 0; i--) {
      var b = this.booms[i]; b.age += dt;
      for (j = 0; j < b.p.length; j++) { b.p[j].x += b.p[j].vx * dt; b.p[j].y += b.p[j].vy * dt; }
      if (b.age > b.life) this.booms.splice(i, 1);
    }
    for (i = 0; i < this.stars.length; i++) this.stars[i].x -= dt * [3, 8, 18][this.stars[i].l];
  };
  Shooter.prototype.render = function () {
    var ctx = this.ctx, w = this.w, h = this.h, i;
    var g = ctx.createLinearGradient(0, 0, 0, h); g.addColorStop(0, PAL.bg); g.addColorStop(1, PAL.bg2);
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    var starCol = ['rgba(167,123,255,0.45)', 'rgba(53,224,255,0.6)', 'rgba(255,255,255,0.85)'];
    for (i = 0; i < this.stars.length; i++) {
      var st = this.stars[i], x = ((st.x % (w + 4)) + (w + 4)) % (w + 4);
      ctx.fillStyle = starCol[st.l]; ctx.fillRect(Math.round(x), Math.round(st.y * (h - 1)), st.l === 2 ? 2 : 1, 1);
    }
    for (i = 0; i < this.enemies.length; i++) { var e = this.enemies[i]; drawSprite(ctx, e.s ? SAUCER : ROCK, e.x, e.y, e.s ? SAUCER_MAP : ROCK_MAP); }
    for (i = 0; i < this.lasers.length; i++) { var L = this.lasers[i]; ctx.fillStyle = PAL.pink; ctx.fillRect(Math.round(L.x), L.y, 4, 1); ctx.fillStyle = PAL.white; ctx.fillRect(Math.round(L.x) + 3, L.y, 1, 1); }
    for (i = 0; i < this.booms.length; i++) {
      var b = this.booms[i], k = b.age / b.life;
      if (k < 0.35) { ctx.fillStyle = PAL.white; ctx.fillRect(Math.round(b.x) - 1, Math.round(b.y) - 1, 3, 3); }
      for (var j = 0; j < b.p.length; j++) { if (Math.random() > k) { ctx.fillStyle = b.p[j].c; ctx.fillRect(Math.round(b.p[j].x), Math.round(b.p[j].y), 1, 1); } }
    }
    var s = this.shipSize(), sx = Math.round(this.shipX), sy = Math.round(this.shipY());
    // engine flicker trail
    ctx.fillStyle = (Math.floor(this.t * 12) % 2) ? PAL.yellow : PAL.red;
    ctx.fillRect(sx - 2, sy + Math.floor(s.h / 2) - 1, 2, 2);
    if (this.shipReady) ctx.drawImage(this.ship, sx, sy, s.w, s.h);
    else { ctx.fillStyle = PAL.cyan; ctx.fillRect(sx, sy + 2, s.w, s.h - 4); }
  };
  Shooter.prototype.staticScene = function () {
    var s = this.shipSize();
    this.shipX = Math.round(this.w * 0.22); this.t = 0;
    this.enemies = [{ x: this.w * 0.62, y: this.h * 0.25, v: 0, s: true, wob: 0 }, { x: this.w * 0.82, y: this.h * 0.55, v: 0, s: false, wob: 0 }];
    this.lasers = [{ x: this.shipX + s.w + 12, y: Math.round(this.shipY() + s.h / 2) }];
    this.booms = [];
    this.render();
  };
  Shooter.prototype.toggle = function () {
    var should = this.visible && this.onscreen;
    if (should && !this.running) {
      this.running = true; var self = this, last = performance.now();
      var loop = function (now) {
        if (!self.running) return;
        var dt = Math.min(0.05, (now - last) / 1000); last = now;
        self.update(dt); self.render();
        self.raf = requestAnimationFrame(loop);
      };
      this.raf = requestAnimationFrame(loop);
    } else if (!should && this.running) {
      this.running = false; cancelAnimationFrame(this.raf);
    }
  };
  function init() {
    var list = document.querySelectorAll('canvas.gtn-shooter__canvas:not([data-init])');
    for (var i = 0; i < list.length; i++) { list[i].setAttribute('data-init', '1'); try { new Shooter(list[i]); } catch (err) { /* decorative only */ } }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
